@if (sectorList().length === 0) {

  <!-- Empty -->
   <div class="flex flex-col items-center justify-center h-full px-4 py-5">
     <div class="text-center">
       <div class="text-md font-title text-gray-400 font-medium">
        {{ isSectors() ? 'No hay sectores' : 'No hay tomas' }}
       </div>

       <div class="flex items-center justify-center">
        <img src="assets/images/no-sectors.svg" alt="No sectors" class="w-64 h-64">
       </div>
     </div>
   </div>

} @else {

  @if (!groupByParent()) {

    <!-- No grouping -->
    @for (sector of sectorList(); track sector.id) {
      <div class="px-4 pt-1 pb-1">
        <sector-list-card
          [sector]="sector"
          (click)="goToSector(sector)">
        </sector-list-card>
      </div>
    }

  } @else {
    @for (group of groupedByParent(); track group.parentId) {
      <div class="mb-3 w-full">

        <div class="px-4 pb-1 flex items-center gap-1 min-w-0">
          <span class="text-sm font-title font-semibold flex-none">{{ group.parentName }}</span>
          @if(group.parentDescription) {
            <span class="text-gray-400 text-sm truncate">{{ group.parentDescription }}</span>
          }
          @if (editable() && group.parentId && editingParentId() === group.parentId) {
            <button
              class="p-0 bg-transparent border-0 self-center flex-none opacity-50 hover:opacity-80 transition-opacity ml-2"
              (click)="cancelEditParent($event)">
              <span class="flex items-center justify-center overflow-hidden size-5">
                <lib-icon name="cancel"></lib-icon>
              </span>
            </button>
          }

          @if (editable() && group.parentId && editingParentId() === group.parentId && isGroupDirty()) {
            <button
              class="disabled:opacity-50 p-0 bg-transparent border-0 self-center flex-none ml-2"
              (click)="openSaveModal($event, group.items)"
              [disabled]="savingParent()">
              <span class="flex items-center justify-center overflow-hidden size-5">
                <lib-icon name="check-mark"></lib-icon>
              </span>
            </button>
          }

          @if (editable() && group.parentId && editingParentId() !== group.parentId) {
            <button
              class="p-0 bg-transparent border-0 self-center flex-none opacity-50 hover:opacity-80 transition-opacity ml-2"
              (click)="startEditParent($event, group.parentId, group.items)">
              <span class="flex items-center justify-center overflow-hidden size-5">
                <lib-icon name="edit"></lib-icon>
              </span>
            </button>
          }
        </div>

        @for (sector of group.items; track sector.id) {
          <div class="px-4 pt-1 pb-1">
            <sector-list-card 
              [sector]="sector" 
              [editMode]="editingParentId() === group.parentId"
              (descriptionChange)="onDescriptionChange(sector.id, $event)"
              (click)="goToSector(sector)">
            </sector-list-card>
          </div>
        }
      </div>
    }
  }
}

<ion-modal [isOpen]="showSaveModal()" [animated]="false" mode="ios" class="confirm-modal" (close)="closeSaveModal()" (willDismiss)="closeSaveModal()">
  <ng-template>
    <div class="py-5 px-6">
      <div class="text-theme-lg font-semibold mb-3">Guardar cambios</div>
      <div class="text-sm text-gray-700 mb-6">¿Deseas guardar los cambios realizados?</div>
      <div class="flex justify-end gap-2">
        <lib-button (click)="closeSaveModal()" size="sm" variant="outline">Cancelar</lib-button>
        <lib-button (click)="confirmSave()" size="sm" variant="primary">Aceptar</lib-button>
      </div>
    </div>
  </ng-template>
</ion-modal>

<ion-modal [isOpen]="showCancelModal()" [animated]="false" class="confirm-modal" (close)="closeCancelModal()" (willDismiss)="closeCancelModal()">
  <ng-template>
    <div class="py-5 px-6">
      <div class="text-theme-lg font-semibold mb-3">Descartar cambios</div>
      <div class="text-sm text-gray-700 mb-6">¿Deseas descartar los cambios realizados?</div>
      <div class="flex justify-end gap-2">
        <lib-button (click)="closeCancelModal()" size="sm" variant="outline">Cancelar</lib-button>
        <lib-button (click)="confirmCancel()" size="sm" variant="primary">Descartar</lib-button>
      </div>
    </div>
  </ng-template>
</ion-modal>
